module.exports = __webpack_public_path__ + "img/tag.55753742.png";